import {IDevice, IDeviceQuery, IDeviceServer} from 'interfaces';
// Not using index import for services to avoid circular dependency
import {axiosAPI} from './API';

interface IAllDevicesResponseServer {
    devices: IDeviceServer[],
    devicesModifiedAt: string,
}

export interface IAllDevicesResponse {
    devices: IDevice[],
    devicesModifiedAt: Date,
}

// Singleton for interacting with devices
class _DevicesService {
    public getAllDevices = (): Promise<IAllDevicesResponse> => {
        const p = axiosAPI.get<IAllDevicesResponseServer>('/allDevices')
            .then((resp) => {
                return {
                    devices: resp.data.devices.map(this.mapDeviceFromServer),
                    devicesModifiedAt: resp.data.devicesModifiedAt ? new Date(resp.data.devicesModifiedAt) : undefined,
                };
            });
        
        p.catch((err) => {
            console.error('Error getting all devices: ', err);
        });

        return p;
    }

    public searchDevices = (query: IDeviceQuery): Promise<IAllDevicesResponse> => {
        const p = axiosAPI.post<IAllDevicesResponseServer>('/devices/search', query)
            .then((resp) => {
                return {
                    devices: resp.data.devices.map(this.mapDeviceFromServer),
                    devicesModifiedAt: resp.data.devicesModifiedAt ? new Date(resp.data.devicesModifiedAt) : undefined,
                };
            });
        
        p.catch((err) => {
            console.error('Error searching devices: ', err);
        });

        return p;
    }

    public publishToDevice = (data: any): Promise<any> => {

        const p = axiosAPI.post<any>('/devices/publish', data)
            .then(() => {
                return;
            });
       
        p.catch((err) => {
            console.error('Error publishing to device: ', err);
            throw err;
        });

        return p;
    }

    public mapDeviceFromServer = (d: IDeviceServer): IDevice => {
        return {
            ...d,
            lastSeen: d.lastSeen ? new Date(d.lastSeen) : undefined,
        }
    }
}

export const DevicesService = new _DevicesService();